import { Card, H5 } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const Paragraph = styled.p`
  margin-bottom: 0;
`;

const StyledCard = styled(Card)`
  min-height: 150px;

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      background: rgba(206, 217, 224, 0.5);
      * {
        opacity: 0.5;
      }
    `};
`;

const PageCard = ({ className, disabled, onClick, text, title }) => {
  return (
    <StyledCard
      className={className}
      {...(disabled ? { disabled } : { onClick, interactive: true })}
    >
      {title && <H5>{title}</H5>}
      {text && <Paragraph>{text}</Paragraph>}
    </StyledCard>
  );
};

PageCard.defaultProps = {
  className: undefined,
  disabled: false,
  onClick: () => {},
  text: undefined,
};

PageCard.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default PageCard;
